import { FC } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@store/store";
import { Box, Stack, Typography } from "@mui/material";
import { setIsOpen } from "@store/accountSetupSlice";
import { useTranslation } from "react-i18next";
import styled from "@emotion/styled";

const CustomButton = styled.button`
  width: 100%;
  background-color: transparent;
  border: solid 1px #bdc1caff;
  border-radius: 4px;
  padding: 4px;
  display: flex;
  justify-content: center;
  cursor: pointer;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

const AccountSetupProgressButton: FC<{
  compact: boolean;
  onOpen?: () => void;
}> = ({ compact, onOpen }) => {
  const { progress } = useSelector((state: RootState) => state.accountSetup);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const onClick = () => {
    dispatch(setIsOpen(true));
    onOpen?.();
  };

  if (progress >= 100) {
    return null;
  }

  return (
    <Box>
      <CustomButton
        style={{ paddingLeft: "5px", paddingRight: "5px" }}
        onClick={onClick}
      >
        <Stack
          flexDirection="row"
          justifyContent="space-between"
          alignItems="center"
          gap="16px"
        >
          {compact ? null : (
            <Typography
              fontSize="14px"
              lineHeight="22px"
              fontWeight="400"
              color="#171A1FFF"
            >
              {t("accountSetupProgress.button")}
            </Typography>
          )}

          <Typography
            fontSize="20px"
            lineHeight="30px"
            fontWeight="600"
            color="#565D6DFF"
          >{`${progress}%`}</Typography>
        </Stack>
      </CustomButton>
    </Box>
  );
};

export default AccountSetupProgressButton;
